import styles from './SellerNavBar.module.css';
import { SellerNavBarItems } from './SellerNavBarItems';
import { DefaultNavItems } from '../DefaultItems/DefaultItems';
import { NavBarBase } from '../NavBarBase/NavBarBase';

export const SellerNavBar = () => {
  return (
    <NavBarBase>
      <div className={styles.innerContainer}>
        <SellerNavBarItems className={styles.leftNavItems} />
        <DefaultNavItems className={styles.rightNavItems} />
      </div>
    </NavBarBase>
  );
};
